<article>
  <table mat-table [dataSource]="subscribers()" class="mat-table-container">
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef>Marque</th>
      <td mat-cell *matCellDef="let element">
        {{ element.advertising?.brands[0].name || '-' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.releaseDate | date: 'dd/MM/YYYY' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="mediaType">
      <th mat-header-cell *matHeaderCellDef>Type de média</th>
      <td mat-cell *matCellDef="let element">
        {{ element.advertising?.mediaType | mediaType }}
      </td>
    </ng-container>
    <ng-container matColumnDef="channel">
      <th mat-header-cell *matHeaderCellDef>Support</th>
      <td mat-cell *matCellDef="let element">
        {{ element.channel?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef>Emplacement/Zone</th>
      <td mat-cell *matCellDef="let element">
        {{
          (['television', 'radio'].includes(element.advertising?.mediaType)
            ? (element.releaseDate | date: 'HH:mm' : '' : 'fr')
            : element.location?.name || '-') || '-'
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="timeSlot">
      <th mat-header-cell *matHeaderCellDef>Tranche horaire</th>
      <td mat-cell *matCellDef="let element">
        {{
          ['television', 'radio'].includes(element.advertising?.mediaType)
            ? getTimeBandFromDate(element.releaseDate)
            : '-'
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>Tarif (FCFA)</th>
      <td mat-cell *matCellDef="let element">
        {{ element.pricing?.price | number }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
